export const DATA = [
    {
        text: "I had my concerns that due to a tight deadline this project can't be done. But Florin proved me wrong not only he delivered an outstanding work but he managed to deliver 1 day prior to the deadline. And when I asked for some revisions he made them in MINUTES. I'm looking forward to work with him again and I totally recommend him. Thanks again Florin!",
        name: "Selena Martinez",
        color: "rgba(103, 28, 201,1.0)",
        image: "https://listkit.cssninja.io/img/photo/avatar/15.jpg"
    },
    {
        text: "Second time hiring him. Finished everything in a timely manner and his work is excellent. Can't recommend him enough.",
        name: "Karie Hehn",
        color: "rgba(123, 34, 224,1.0)",
        image: "https://listkit.cssninja.io/img/photo/avatar/21.jpg"
    },
    {
        text: "Alexandru Florin never fails to impress me by the quality of his work and delivering on time. When it comes to front-end, he is definitely my go to guy. Always is a pleasure to work with Alexandru even when deadlines are tight and pressure is great. It's reassuring to have a project in such good hands.",
        name: "Steve P. Huard",
        color: "rgba(73, 17, 138,1.0)",
        image: "https://listkit.cssninja.io/img/photo/avatar/27.jpg"
    },
    {
        text: "Florin has been of great help on our different web projects. He is very trustworthy and serious in the work done. Keep on the good work and energy, been a pleasure to collaborate.",
        name: "Matt Dilon",
        color: "rgba(121, 0, 196,1.0)",
        image: "https://listkit.cssninja.io/img/photo/avatar/24.jpg"
    },
    {
        text: "I hired Florin Pop based on others positive experiences, and I understand why he's so highly rated. His code is very clean, he communicates well, and he likes to offer alternative solutions.",
        name: "Corina Sparks",
        color: "rgba(85, 34, 153,1.0)",
        image: "https://listkit.cssninja.io/img/photo/avatar/12.jpg"
    },
]